import { extractSectionId } from "//finloup.com/cdn/shop/t/53/assets/theme.js?v=180813259853650745581779010170";
import { fetchCart } from "//finloup.com/cdn/shop/t/53/assets/theme.js?v=180813259853650745581779010170";

(async function cart_check() {
        let cart = await fetchCart;
        let token = cart["token"];

        if (getCookie('clear_cart') === token) {
            await fetch(window.Shopify.routes.root + 'cart/clear.js').then((response) => {
                return response;
            }).then(async (response) => {
                let cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
                document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
                    bubbles: true,
                    detail: {
                        baseEvent: "cart:clear",
                        cart: cartContent
                    }
                }));
                deleteCookieFromDjango('clear_cart');
                if (window.location.pathname === '/cart') window.location.reload();
            });
        } else {

            let query = `query getProductBadges($key: String = "badges", $namespace: String = "custom", $handle: String = "") {
                product(handle: $handle) {
                  metafield(key: $key, namespace: $namespace) {
                    value
                  }
                }
              }`;
            let cartProductsNA = {};

            for (var i = 0; i < cart.items.length; i++) {
                let item = cart.items[i];
                let data = JSON.stringify({
                    query: query,
                    variables: {"handle": item.handle, "key": "badges", "namespace": "custom"}
                });

                $.ajax({
                    method: 'POST',
                    url: GRAPHQL_URL,
                    async: false,
                    dataType: 'json',
                    headers: {
                      'X-Shopify-Storefront-Access-Token': STOREFRONT_ACCESS_TOKEN
                    },
                    data: data,
                    contentType: 'application/json',
                    success: (result) => {
                        if ('data' in result && result.data.product != null && result.data.product.metafield != null &&
                            result.data.product.metafield.value.includes('available_soon'))
                            cartProductsNA[item.variant_id] = 0;
                    },
                    error: (result) => {
                        //console.log(result);
                    }
                });
            }

            if (Object.keys(cartProductsNA).length) {
                const cart_id = extractSectionId(document.getElementById("cart-drawer"));
                cart = await (await fetch(`${Shopify.routes.root}cart/update.js`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        updates: cartProductsNA,
                        sections: [cart_id]
                    })
                })).json();
                document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
                    bubbles: true,
                    detail: {
                        baseEvent: "line-item:change",
                        cart: cart
                    }
                }));

                setCookie('NAproductInCart',Object.keys(cartProductsNA).join(','), 3650);
                if (getCookie('b2bEnabled') === 'true') showNAproductsInCartPopup();
            }
        }

})();

export function showNAproductsInCartPopup() {
    let na_products = getCookie('NAproductInCart');
    if (na_products === '' || window.location.pathname.includes("product")) return;

    const cartProductNAPopup = document.querySelector('#cart-product-na-popup');

    let select = cartProductNAPopup.querySelector('#variant_ids_select');
    na_products.split(',').forEach((prod) => {
        let option = document.createElement('option')
        option.value = prod;
        option.selected = true;
        select.appendChild(option);
    });

    cartProductNAPopup.querySelector('button.popup--button').addEventListener('click', (e) => {
        cartProductNAPopup.querySelector('#popup_main_content').style.display = 'none';
        let notify_form = cartProductNAPopup.querySelector('#popup_custom_liquid');
        notify_form.style.display = 'block';
        notify_form.style.width = '448px';
        notify_form.style.height = '168px';
    });

    cartProductNAPopup.querySelector('.popup--close').addEventListener('click', () => {
        if (window.location.pathname === '/cart') window.location.reload();
    });
    cartProductNAPopup.querySelector('.popup--overlay').addEventListener('click', () => {
        if (window.location.pathname === '/cart') window.location.reload();
    });

    $(cartProductNAPopup).show();
    setCookie('NAproductInCart', '', 0);
}